import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { TranslatePipe } from '@ngx-translate/core'
import { Checkbox } from 'primeng/checkbox'
import { InputText } from 'primeng/inputtext'
import { TableModule } from 'primeng/table'

import { BaseRoleEditModel, BaseRolesListModel, RoleFormMode } from '../../models'

@Component({
  selector: 'app-role-form',
  templateUrl: 'role-form.component.html',
  styleUrls: ['role-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, TranslatePipe, InputText, TableModule, Checkbox, FormsModule],
})
export class RoleFormComponent {
  protected readonly editModel = inject(BaseRoleEditModel)
  protected readonly listModel = inject(BaseRolesListModel)
  protected readonly TYPES = { RoleFormMode }
}
